import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


interface BinProps extends StyledProps {
  color?: string;
}

const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const CarAlertSVG: React.FunctionComponent<BinProps> = ({ ...rest }) => {
  return (
    <StyledContainer {...rest}>
      <svg width="25" height="24" fill="none" viewBox="0 0 25 24">
        <path
          fill="#070B16"
          d="M21.578 9.188h-2.105l-.585-1.463a3.918 3.918 0 00-3.656-2.475h-4.464c-1.62 0-3.055.971-3.656 2.475l-.585 1.463H4.422a.422.422 0 00-.41.524l.212.843c.047.188.215.32.409.32h.706a2.234 2.234 0 00-.777 1.688v1.687c0 .567.217 1.078.563 1.474v1.901c0 .621.504 1.125 1.125 1.125h1.125c.621 0 1.125-.504 1.125-1.125V16.5h9v1.125c0 .621.504 1.125 1.125 1.125h1.125c.621 0 1.125-.504 1.125-1.125v-1.9a2.23 2.23 0 00.562-1.475v-1.688c0-.675-.304-1.275-.776-1.687h.706a.422.422 0 00.41-.32l.21-.843a.422.422 0 00-.41-.524zM9.2 8.56c.256-.64.876-1.061 1.566-1.061h4.465c.69 0 1.31.42 1.567 1.06l.7 1.752h-9l.702-1.751zm-1.826 5.682c-.675 0-1.125-.449-1.125-1.122C6.25 12.45 6.7 12 7.375 12s1.687 1.01 1.687 1.682c0 .673-1.012.561-1.687.561zm11.25 0c-.675 0-1.688.112-1.688-.56 0-.674 1.013-1.683 1.688-1.683s1.125.449 1.125 1.121c0 .673-.45 1.122-1.125 1.122z"
        />
        <circle cx="6" cy="6" r="5.5" fill="#fff" stroke="#000"></circle>
        <path
          fill="#070B16"
          d="M6.938 8.063a.939.939 0 01-1.875 0 .939.939 0 011.875 0zM5.17 3.295l.16 3.188c.007.15.13.267.28.267h.778c.15 0 .273-.118.28-.267l.16-3.188A.281.281 0 006.549 3H5.451a.281.281 0 00-.281.295z"
        />
      </svg>
    </StyledContainer>
  );
};

export default CarAlertSVG;
